import { render, staticRenderFns } from "./ControlCorreos.vue?vue&type=template&id=c83930ca&"
import script from "./ControlCorreos.vue?vue&type=script&lang=js&"
export * from "./ControlCorreos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports